/* eslint-disable no-restricted-imports */
import { DirectPayForType, DirectPromotionGoalUI } from '../../../../data-layer/direct/types';
import { MIN_WEEKLY_LIMIT_VALUE } from '../../../../routing/business/ContentPromotion/constants';
import { MIN_BUDGET_RATIO } from '../constants';

export const getMinWeeklyLimit = (
    selectedGoals?: DirectPromotionGoalUI,
    payFor?: DirectPayForType,
) => {
    if (payFor === DirectPayForType.CLICKS) {
        return MIN_WEEKLY_LIMIT_VALUE;
    }

    const selectedGoalsIds = selectedGoals && Object.keys(selectedGoals);

    const minBudget =
        selectedGoalsIds &&
        selectedGoalsIds.reduce((res, id) => {
            const budget = selectedGoals[id].cost;

            if (budget) {
                res += budget * MIN_BUDGET_RATIO;
            }

            return res;
        }, 0);

    if (!minBudget) {
        return;
    }

    return Math.max(minBudget, MIN_WEEKLY_LIMIT_VALUE);
};
